import axios from "infra/http";
import { useQuery } from "react-query";
import { HistoricoEquipamentoLogs } from "./../typings/index";

function useHistoricoEquipamento(id: string | undefined) {
  return useQuery(
    `/v1/equipamento/${id}/historico`,
    async () => {
      const { data } = await axios.get<HistoricoEquipamentoLogs[]>(
        `/v1/equipamento/${id}/historico`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useHistoricoEquipamento;
